import React, { ReactElement } from "react";
import { MenuItemData } from "../../../utilities/menus/MenuStruct";
import "./style.scss";
import { BsCaretDownFill, BsCaretUpFill } from "react-icons/bs";
import { Colors } from "../../../utilities/colors";

export type MenuItemProps = {
  title: string;
  icon?: ReactElement | null;
  children?: Array<MenuItemData> | null;
  link?: string | null;
  onClick?: () => void;
  level?: number;
  opened?: boolean;
  active?: boolean;
  openMenu?: boolean;
};

const MenuItem = ({
  icon,
  link,
  title,
  children,
  onClick,
  level,
  opened,
  active,
  openMenu,
}: MenuItemProps) => {
  return (
    <div
      className={
        "menu-item d-flex align-items-center" + (level === 1 ? "ps-4" : "") + (active ? " menu-active " : "")
      }
      onClick={onClick}
    >
      {icon}
      {openMenu && <>
        <span className="base-text fw-700 ps-2">{title}</span>
        {children && children?.length > 0 && (
          <span className="flex1 d-flex justify-content-end">
            {!opened && <BsCaretDownFill color={Colors.darkGray} />}
            {opened && <BsCaretUpFill color={Colors.darkGray} />}
          </span>
        )}
      </>}
    </div>
  );
};

export default MenuItem;
